import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import BrowserStore from '../../browser/stores/BrowserStore';
import { ERROR_VIEW_CODE } from '../../constants';
import AsyncActionStore from '../../stores/AsyncActionStore';
import CustomizeUIStore from '../../stores/CustomizeUI/CustomizeUIStore';
import FlagStore from '../../stores/FlagStore';
import PasswordlessAuthStore from '../../stores/PasswordlessAuthStore';
import BrowserLogin from '../Authentication/BrowserLogin';
import ContentFilteringPage from '../BlockPage/ContentFilteringPage';
import MaliciousThreatPage from '../BlockPage/MaliciousThreatPage';
import BrowserBarPreview from '../BrowserBarOptions/BrowserBarPeview';
import BaseBrowserPreview from './preview/BaseBrowserPreview';
import { CUSTOMIZATION_TYPE } from '../../stores/CustomizeUI/CustomizeUIConstants';

class PreviewController extends Component {
    static propTypes = {
        customizeUI: CustomizeUIStore.PropType,
        store: MobxPropTypes.observableObject,
    };

    componentDidMount() {
        this.props.customizeUI.loadBrowserStoresInit();
    }

    renderOptionPreview = {
        [CUSTOMIZATION_TYPE.CONTENT_FILTERING]: (store) => <BaseBrowserPreview
            withStores={(stores) => {
                stores.browser.isErrorPage = true;
                stores.browser.errorPageDetail = {
                    errorViewCode: ERROR_VIEW_CODE.BLOCKED_SITE,
                };
                return stores;
            }}
        >
            <ContentFilteringPage
                {...(store.enabled.getValue() ? store.getValue() : {})}
                key={store.content.key}
            />
        </BaseBrowserPreview>,
        [CUSTOMIZATION_TYPE.MALICIOUS_THREAT]: (store) => <BaseBrowserPreview
            withStores={(stores) => {
                stores.browser.isErrorPage = true;
                stores.browser.errorPageDetail = {
                    errorViewCode: ERROR_VIEW_CODE.BLOCKED_UNSAFE,
                };
                stores.browser.tiScan = BrowserStore.SCAN_STATUS.BLOCK;
                return stores;
            }}
        >
            <MaliciousThreatPage
                {...(store.enabled.getValue() ? store.getValue() : {})}
                key={store.content.key}
            />
        </BaseBrowserPreview>,
        [CUSTOMIZATION_TYPE.BROWSER_BAR]: (store) => <div style={{ borderTop: '1px solid #00000024' }}>
            <BrowserBarPreview
                browserBarOptions={store.getValue()}
                key={store.popupContent.key}
            />
        </div>,
        [CUSTOMIZATION_TYPE.EXIT_MESSAGE]: (store) => <BaseBrowserPreview
            key={store.content.key + store.option.getValue()}
            withStores={(stores) => {
                const exitMessage = store.getValue();
                stores.browser.notification = BrowserStore.NOTIFICATION.NEW_CONFIRM_EXIT_ISOLATION;
                stores.browser.setExitIsoText(exitMessage.option === 'DEFAULT' ? null : exitMessage.content);
                stores.env.productId = 'UISL';
                stores.env.isBrowserDefense = false;
                stores.env.isWebmailDefense = false;
                stores.env.isUrlIsolation = true;
                stores.env.isSaasIsolation = false;
                return stores;
            }}
        />,
        [CUSTOMIZATION_TYPE.REGISTRATION_NOTICE]: (store) => <BrowserLogin
            passwordlessAuth={new PasswordlessAuthStore({
                submitEmailState: AsyncActionStore.resolved({
                    type: 'registrationNotice',
                    content: store.getValue(),
                }),
                flipNextStore: new FlagStore(true),
                acceptPrivacyPolicy: () => {},
                startAgain: () => {},
            })}
            key={store.content.key}
        />,
    };

    render() {
        const { store } = this.props;
        return this.renderOptionPreview[store.metadata.customizationType]?.(store);
    }
}

export default inject('customizeUI')(observer(PreviewController));
